<template>
  <div class="mobile-record">
    <div class="record-list">
      <div class="list-item" v-for="(item, index) in dataArr" :key="index">
        <div>
          <div class="item-tit" style="min-width: 2rem">儲值時間</div>
          <div class="item-val">{{ item.times }}</div>
          <div class="item-tit" style="margin-top: 0.1rem">儲值管道</div>
          <div class="item-val">
            {{
              item.payType == 1
                ? "Google"
                : item.payType == 2
                ? "Appstore"
                : item.payType == 3
                ? "Mycard"
                : item.payType == 4
                ? "HMS"
                : "--"
            }}
          </div>
        </div>
        <div style="margin-left: 0.2rem; min-width: 1.4rem">
          <div class="item-tit">角色id</div>
          <div class="item-val">{{ item.rid }}</div>
          <div class="item-tit" style="margin-top: 0.1rem">購買商品</div>
          <div class="item-val">{{ item.productName }}</div>
        </div>
        <div style="margin-left: 0.2rem; min-width: 2rem">
          <div class="item-tit">伺服器</div>
          <div class="item-val">{{ item.zoneName }}</div>
          <div class="item-tit" style="margin-top: 0.1rem">商品價格</div>
          <div class="item-val">{{ (item.price).toFixed(2) }} TWD</div>
        </div>
      </div>
    </div>
    <el-pagination
      class="tz"
      layout="prev, pager, next"
      :total="total"
      :page-size="6"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { orderList, serverList, roleList } from "@/api/game";
import { getAccessToken } from "@/util/auth";
import { game } from "@/proto/payload";
export default {
  data() {
    return {
      dataArr: [],
      key: "",
      loading: true,
      pagination: {
        page: 1,
        pageSize: 6,
      },
      nowServe: "",
      nowUser: "",
      serveArr: [],
      roleArr: [],
      total: 0,
    };
  },
  methods: {
    handleBuy() {
      this.$router.push({
        path: "/home",
      });
    },

    getOrderList() {
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        keys: this.key,
        serverId: this.nowServe,
        rid: this.nowUser,
      };
      this.loading = true;
      orderList(params)
        .then((res) => {
          const data = res.data;
          this.dataArr = data.records;
          this.total = data.total;
          this.loading = false;
        })
        .catch((res) => {
          this.loading = false;
        });
    },

    // 获取角色列表
    getRoleList() {
      const params = {
        appId: "8",
        serverId: this.nowServe || "",
      };
      roleList(params)
        .then((res) => {
          const data = res.data;
          this.roleArr = data;
        })
        .catch((res) => {});
    },

    getServerList() {
      const params = {
        appId: "8",
      };
      serverList(params)
        .then((res) => {
          const data = res.data;
          this.serveArr = data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleChangeServe() {
      this.nowUser = "";
      this.getRoleList();
    },

    handleSearch() {
      this.pagination = {
        page: 1,
        pageSize: 6,
      };
      this.getOrderList();
    },
    // 下一页
    handleCurrentChange(val) {
      console.log(val);
      this.pagination.page = val;
      this.getOrderList();
    },
  },
  mounted() {
    this.getOrderList();
    this.getServerList();
  },
};
</script>

<style lang="less" scoped>
.mobile-record {
  padding: 0 0.4rem;

  .record-list {
    padding: 0 0.4rem;
    .list-item {
      padding: 0.3rem;
      margin-top: 0.2rem;
      width: 100%;
      height: 2rem;
      background: url("../../assets/imagePai/mobile/jilu.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      .item-tit {
        color: #fff;
        font-weight: bold;
        font-size: 0.2rem;
      }
      .item-val {
        color: #000;
        font-weight: bold;
        font-size: 0.25rem;
      }
    }
  }

  .tz {
    margin-top: 0.1rem;
    height: 1rem;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .no-info {
    width: 100%;
    height: 100%;
    background: #bec5cd;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #717882;
    font-weight: bold;
    font-size: 0.35rem;
  }

  ::v-deep {
    .el-pager li {
      background: none;
      color: #133d6c;
      font-size: 0.3rem;
      min-width: 0.5rem;
    }

    .el-pager li.active {
      color: #ff8929;
      cursor: default;
    }

    .el-pager li :hover {
      color: #ff8929 !important;
    }
    .el-pager li.btn-quicknext,
    .el-pager li.btn-quickprev {
      color: #133d6c;
    }
    .el-icon-arrow-right:before {
      content: ""; //右边“下一页”三角箭头
    }
    .el-icon-arrow-left:before {
      content: ""; //左边“上一页”三角剪头
    }
    .el-pagination button:disabled {
      background-color: transparent;
    }
    .el-pagination .btn-next,
    .el-pagination .btn-prev {
      background: url(../../assets/imageJie/p-right.png) center no-repeat;
      background-size: 0.2rem 0.24rem;
    }
    .el-pagination .btn-prev {
      background: url(../../assets/imageJie/p-left.png) center no-repeat;
      background-size: 0.2rem 0.24rem;
    }
    .el-pagination button {
      min-width: 0.5rem;
    }
  }
}
</style>